import { Component, Inject, Injector, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { AbstractComponent, Channel, ChannelService, Tabulation, TabulationService, } from 'lib-trend-core';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'app-tabulation-modal',
    // templateUrl: './tabulation-modal.component.html',
    templateUrl: './tabulation-modal.v2.component.html',
    styleUrl: './tabulation-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabulationModalComponent extends AbstractComponent implements OnInit, OnDestroy {

  filterControlChannel: FormControl = new FormControl('');

  public channel!: Channel;
  public tabulation: Tabulation;
  public listChannel!: Channel[];

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<TabulationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Tabulation,
    private channelService: ChannelService,
    private tabulationService: TabulationService,
  ) {
    super(injector);
    this.createForm();
  }

  ngOnInit(): void {
    this.isNew = !!this.data ? false : true;
    this.getListChannel();

    if (!this.isNew) {
      this.populateFormWithData();
    }
  }

  private populateFormWithData(): void {
    this.tabulation = this.data;
    this.formGroup.patchValue({ ...this.data, channel: this.data.channel._id });
    this.tabulation.channel = this.data.channel;
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      channel: [null, Validators.required],
      name: [null, Validators.required],
      description: [null],
    });

    this.formGroup.valueChanges.subscribe(value => {
      if (!this.tabulation) {
        this.tabulation = {} as Tabulation;
      }
      Object.assign(this.tabulation, value);
    })
  }

  onSelectChannel(event: MatSelectChange): void {
    this.formGroup.get('channel').setValue(event.source.value);
    this.channel = event.source.value;
  }

  private getListChannel(): void {
    this.channelService.getList().subscribe({
      next: (response: Channel[]) => {
        this.listChannel = response;
      },
      error: (error) => this.alertService.error(error),
    })
  }

  save(): void {
    this.loading = true;
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup);
      return;
    };

    const saveObservable = this.isNew
      ? this.tabulationService.create(this.tabulation)
      : this.tabulationService.update(this.tabulation._id, this.tabulation);

    saveObservable.pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.alertService.success(this.t('tabulation.modal.saveSuccess'));
        this.dialogRef.close(response);
      },
      error: (error) => {
        this.alertService.error(error);
        this.loading = false;
      },
      complete: () => { this.loading = false }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

}
